import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MemberNiceNameEdit',
  data: function data() {
    return {
      props: {
        multiple: false
      },
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      imageUrl: null,
      imageUrl2: null,
      fileList: [],
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      title: '',
      citys: [],
      form: {
        memberId: null,
        nickName: null,
        headUrl: null,
        idNo: null,
        name: null,
        selectCitys: []
      },
      rules: {
        idNo: [{
          required: true,
          message: '请输入身份证号码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }],
        headUrl: [{
          required: true,
          message: '请上传头像',
          trigger: 'blur'
        }],
        selectCitys: [{
          required: true,
          message: '请选择城市',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleAvatarSuccess2: function handleAvatarSuccess2(res, file) {
      this.imageUrl2 = this.downloadUrl + res.body.url;
      this.form.matchmakerCodeUrl = res.body.url;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = this.downloadUrl + res.body.url;
      this.form.headUrl = res.body.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.nickName = data.nickName;
      this.form.memberId = data.memberId;
      this.form.headUrl = data.headUrl;
      if (data.headUrl.indexOf('http') !== -1) {
        this.imageUrl = data.headUrl;
      } else {
        this.imageUrl = this.downloadUrl + data.headUrl;
      }
      if (data.matchmakerCodeUrl.indexOf('http') !== -1) {
        this.imageUrl2 = data.matchmakerCodeUrl;
      } else {
        this.imageUrl2 = this.downloadUrl + data.matchmakerCodeUrl;
      }
      this.form.name = data.name;
      this.form.idNo = data.idNo;
      this.initCitys();
      var dataCitys = [];
      dataCitys.push(data.province + '');
      dataCitys.push(data.city + '');
      dataCitys.push(data.area + '');
      this.form.selectCitys = dataCitys;
      console.log(this.form.selectCitys);
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.form.province = _this2.form.selectCitys[0];
              _this2.form.city = _this2.form.selectCitys[1];
              _this2.form.area = _this2.form.selectCitys[2];
              _context2.n = 1;
              return api.UPDATE_MEMBER(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_GIFT(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.memberId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};